"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceWOidStruct = exports.ServiceStruct = exports.Test = exports.ServiceStatsStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.ServiceStatsStruct = (0, superstruct_1.type)({
    tagUpdatedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    lastTag: (0, superstruct_1.optional)((0, superstruct_1.defaulted)((0, superstruct_1.number)(), 0)),
});
exports.Test = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    description: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), ''),
    name: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.ServiceStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), 'New Service'),
    description: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), ''),
    color: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), '#D7D0FF'),
    queueId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    scheduleId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    inventoryId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    formId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    categoryId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    tagPrefix: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), 'A'),
    position: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
exports.ServiceWOidStruct = (0, superstruct_1.omit)(exports.ServiceStruct, ['id']);
exports.ServiceStruct.type = 'Service';
//# sourceMappingURL=service.js.map